import { AccountConfigs } from "./Account/Account.config";
import { ClientsFornecedoresTableConfig, DispositivoMedicaoConfigs, MachinesTableConfig, MaterialTableConfig, NotificationsTableConfigs } from "./Configuration/Configuration.config";
import { DespesasTableConfigs } from "./Despesas/Despesas.config";
import { FaturacaoClientesTableConfigs } from "./Faturacao/FaturacaoClientes/FaturacaoClientes.config";
import { FaturacaoFornecedoresTableConfigs } from "./Faturacao/FaturacaoFornecedores/FaturacaoFornecedoresConfig";
import { NotasCreditoClientesTableConfigs } from "./NotasCredito/NotasCreditoClientes/NotasCreditoClientes.config";
import { NotasCreditoFornecedoresTableConfigs } from "./NotasCredito/NotasCreditoFornecedores/NotasCreditoFornecedores.config";
import { EncomendasTableConfigs } from "./NotasEncomenda/Encomendas.config";
import { NotasEncomendaTableConfigs } from "./NotasEncomenda/NotasEncomenda.config";
import { ObrasTableConfigs } from "./Obras/Obras.config";
import { OrcamentosTableConfigs } from "./Orcamentos/Orcamentos.config";
import { RecibosTableConfigs } from "./Recibos/RecibosConfig";
import { ConfigMap } from "..";
import { OcorrenciasTableConfig } from "./Ocorrencias/Ocorrencias.config";
import { EntradasMaterialConfigs } from "./EntradasMaterial/EntradasMaterial.config";
import { NaoConformidadesClientesConfig } from "./NaoConformidades/Cliente/NaoConformidadesClientes.config";
import { NaoConformidadesFornecedoresConfig } from "./NaoConformidades/Fornecedor/NaoConformidadesFornecedores.config";


const configMap: ConfigMap = {
    'orcamentos': OrcamentosTableConfigs,
    'clients': ClientsFornecedoresTableConfig,
    'fornecedores': ClientsFornecedoresTableConfig,
    'obras': ObrasTableConfigs,
    'machines': MachinesTableConfig,
    'faturacao-clientes': FaturacaoClientesTableConfigs,
    'faturacao-fornecedores': FaturacaoFornecedoresTableConfigs,
    'notas-credito-clientes': NotasCreditoClientesTableConfigs,
    'notas-credito-fornecedores': NotasCreditoFornecedoresTableConfigs,
    'recibos': RecibosTableConfigs,
    'notas-encomenda': NotasEncomendaTableConfigs,
    'encomendas': EncomendasTableConfigs,
    'despesas': DespesasTableConfigs,
    'utilizadores': AccountConfigs,
    'notificacoes/configurations': NotificationsTableConfigs,
    'dispositivo-medicao': DispositivoMedicaoConfigs,
    'ocorrencias': OcorrenciasTableConfig,
    'entradas-material': EntradasMaterialConfigs,
    'materiais': MaterialTableConfig,
    'nao-conformidades-clientes': NaoConformidadesClientesConfig,
    'nao-conformidades-fornecedores': NaoConformidadesFornecedoresConfig,
}


export default configMap;